import { jsx } from 'react/jsx-runtime';
import 'date-fns-tz';
import { cn } from '../../utils/formatters.js';
import '@radix-ui/react-label';
import './alert.js';
import '@radix-ui/react-avatar';
import './badge.js';
import 'lucide-react';
import 'react';
import 'react-day-picker';
import './button.js';
import './chart.js';
import '@radix-ui/react-checkbox';
import '@radix-ui/react-collapsible';
import 'cmdk';
import '@radix-ui/react-dialog';
import '@radix-ui/react-popover';
import 'vaul';
import '@radix-ui/react-dropdown-menu';
import '@radix-ui/react-progress';
import './radio-group.js';
import '@radix-ui/react-select';
import './time-input.js';
import '@radix-ui/react-separator';
import './sidebar.js';
import 'react-toastify';
import '@radix-ui/react-switch';
import '@radix-ui/react-tabs';
import '@radix-ui/react-tooltip';
import '@clerk/clerk-react';
import '../../lib/toast.js';
import 'react-router-dom';
import '../../contexts/AppContext.js';
import '../../contexts/OrganizationContext.js';
import 'axios';
import '@tanstack/react-query';
import '../page-layout/FormPageLayout.js';
import '../form/RichTextEditor.js';
import '../crud/CrudDetailView.js';
import '../crud/CrudFormView.js';
import '../../contexts/SidebarContext.js';
import '../../contexts/ThemeContext.js';
import '@dnd-kit/core';
import '@dnd-kit/sortable';
import '@dnd-kit/utilities';

function Textarea({ className, ...props }) {
    return (jsx("textarea", { "data-slot": "textarea", className: cn('border-input placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-ring/50 aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:bg-input/30 flex field-sizing-content min-h-16 w-full rounded-md border bg-transparent px-3 py-2 text-base shadow-xs transition-[color,box-shadow] outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 md:text-sm', className), ...props }));
}

export { Textarea };
//# sourceMappingURL=textarea.js.map
